/**
 * AUTO-GENERATED with npm run generateIcons
 */
import { forwardRef, ForwardRefExoticComponent, RefAttributes } from "react";
import Icon from "@ant-design/icons";
import { IconComponentProps } from "@ant-design/icons/lib/components/Icon";

import { classNames } from "../../helpers";

const svg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 28 28">
        <g clipPath="url(#mid-truck_svg__a)">
            <path
                fill="currentColor"
                d="M27.538 10.873h-2.502V3.448c0-1.134-.888-2.048-1.98-2.048H1.98C.888 1.4 0 2.319 0 3.448v17.975c0 1.134.888 2.048 1.98 2.048h2.839c.578 1.579 1.95 2.78 3.593 3.057 2.335.397 4.411-.995 5.17-3.057h9.47c1.096 0 1.98-.919 1.98-2.048v-7.378h2.496a.47.47 0 0 0 .463-.478v-2.215a.47.47 0 0 0-.463-.479zM10.576 22.327l-.019.043c-.032.072-.07.144-.11.206l-.028.043a1.5 1.5 0 0 1-.417.416q-.095.066-.203.115c-.014.005-.028.015-.042.02a1.5 1.5 0 0 1-.61.11c-.037 0-.079-.01-.116-.015a2 2 0 0 1-.222-.043q-.056-.016-.11-.038a2 2 0 0 1-.204-.096c-.028-.014-.06-.033-.088-.048a1.5 1.5 0 0 1-.25-.205 2 2 0 0 1-.199-.259c-.018-.029-.032-.062-.046-.09a1.2 1.2 0 0 1-.092-.211c-.014-.038-.023-.077-.037-.115a2 2 0 0 1-.042-.23c0-.038-.01-.076-.01-.12 0-.1 0-.2.02-.305q.026-.173.087-.326.01-.021.019-.043.048-.11.11-.206.016-.02.028-.043a1.5 1.5 0 0 1 .375-.387l.042-.029q.095-.064.198-.115c.014-.005.028-.014.042-.019a1.5 1.5 0 0 1 .61-.11c.037 0 .074.01.116.01q.111.015.222.043c.037.01.074.024.111.033q.106.044.203.096c.028.014.06.029.088.048.18.12.333.277.449.464.018.029.032.062.046.09q.057.103.093.211.02.058.032.115.027.115.042.23c0 .038.009.076.009.12 0 .1 0 .2-.019.305a1.5 1.5 0 0 1-.088.326zm11.394-2.114h-8.31c-.536-1.675-1.951-2.962-3.662-3.254-2.41-.407-4.546 1.082-5.244 3.254H3.06V4.658h18.904v15.555z"
            />
        </g>
        <defs>
            <clipPath id="mid-truck_svg__a">
                <path fill="currentColor" d="M0 1.4h28v25.2H0z" />
            </clipPath>
        </defs>
    </svg>
);

type Props = IconComponentProps & RefAttributes<HTMLSpanElement>;

const SvgMidTruck: ForwardRefExoticComponent<Props> = forwardRef((props, ref) => (
    <Icon component={svg} {...props} ref={ref} className={classNames("svg-mid-truck", props.className)} />
));

export default SvgMidTruck;
